import * as Sentry from '@sentry/react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';
import { useEffect } from 'react';
import { separators } from './constants';
import { is } from './utils';

export const initSentry = () => {
  if (is.localhost) {
    console.warn("Sentry didn't initialize for localhost");

    return;
  }

  const hostname = window.location.hostname.split(separators.dot);

  Sentry.init({
    dsn: 'https://a36e43e68d65fdddfeed9319765f530e@o4510416223993856.ingest.de.sentry.io/4510416226287696',
    environment: `${hostname[0]}-frontend`,
    integrations: [
      // Збирає метрики продуктивності у браузері:
      // час завантаження сторінок
      // HTTP-запити (XHR / fetch)
      // взаємодії користувача
      // навігацію браузера
      // Sentry.browserTracingIntegration(),

      // запис екрана користувача
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
    ],
    tracesSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    beforeSend(event) {
      if (is.localhost) {
        return null;
      }

      return event;
    },
  });
};
